/** Used by BULK_DELETE action, to map entities to api endpoints */
export const DELETE = {
  apiKeys: 'deleteAPIKey',
  appearances: 'deleteAppearance',
  catalogRepositories: 'deleteServiceCatalogSource',
  configRepositories: 'deleteConfigRepository',
  credentials: 'deleteCredential',
  externalBackends: 'deleteExternalBackend',
  infraPolicies: 'deleteInfraPolicy',
  invites: 'deleteInvitation',
  members: 'removeOrgMember',
  projects: 'deleteProject',
  project: {
    environments: 'deleteProjectEnvironment',
    kpis: 'deleteKPI',
    pipelines: 'deletePipeline',
  },
  plugins: 'deletePluginRegistryPlugin',
  pluginManagers: 'deletePluginManager',
  pluginVersions: 'deletePluginRegistryPluginVersion',
  roles: 'deleteOrgRole',
  stacks: 'deleteServiceCatalog',
  teamMembers: 'unassignMemberFromTeam',
  teams: 'deleteTeam',
  watchRules: 'deleteWatchRule',
}

/** Used by FETCH_AVAILABLE action, to map entities to api endpoints */
export const GET = {
  apiKeys: 'getAPIKeys',
  appearances: 'listAppearances',
  ssos: 'listAuthentications',
  catalogRepositories: 'getServiceCatalogSources',
  childOrgs: 'getOrgChildren',
  cloudProviders: 'getCloudProviders',
  configRepositories: 'getConfigRepositories',
  credentials: 'listCredentials',
  environments: 'getEnvironments',
  cloudAccounts: 'getCloudAccounts',
  environmentComponents: 'getEnvironmentComponents',
  components: 'getComponents',
  environmentTypes: 'getEnvironmentTypes',
  events: 'getOrgEvents',
  externalBackends: 'getExternalBackends',
  infraPolicies: 'getInfraPolicies',
  inventoryResources: 'getInventoryResources',
  terraformOutputs: 'getTerraformOutputs',
  invites: 'getOrgMembers',
  labels: 'listResourceLabels',
  members: 'getOrgMembers',
  pipelines: 'getPipelines',
  plugins: 'listPlugins',
  pluginWidgets: 'listPluginWidgets',
  componentPluginWidgets: 'listComponentPluginWidgets',
  pluginManagers: 'listPluginManagers',
  pluginRegistries: 'getPluginRegistries',
  pluginVersions: 'listPluginVersions',
  policies: 'getPolicies',
  projects: 'getProjects',
  project: {
    kpis: 'getProjectKPIs',
    pipelines: 'getProjectPipelines',
  },
  resourceTypes: 'listResourceTypes',
  roles: 'getOrgRoles',
  catalogRepositoryVersions: 'listCatalogRepositoryVersions',
  stacks: 'getServiceCatalogs',
  stackVersions: 'getServiceCatalogVersions',
  stackVersionAdoption: 'getStackVersionAdoption',
  tags: 'getOrgEventsTags',
  teamMembers: 'getTeamMembers',
  teams: 'getTeams',
  workers: 'getWorkers',
}

export default {
  DELETE,
  GET,
}
